export const firebaseConfig = {
  apiKey: "AIzaSyAikF5Ub5KZfrj2qnFDaPNvnnPb1nNf4mc",
  authDomain: "first-on-scene-50a1c.firebaseapp.com",
  projectId: "first-on-scene-50a1c",
  storageBucket: "first-on-scene-50a1c.firebasestorage.app",
  messagingSenderId: "756842507426",
  appId: "1:756842507426:web:dcd2467de3a0dd0dd9bbfb",
  measurementId: "G-SEJSL1XDRR"
};